<template>
  <div class="carousel-container" ref="carouselRef">
    <div
      class="carousel-content"
      :class="{ 'animate-in': isVisible, 'animate-out': !isVisible }"
    >
      <!-- 左侧图片 -->
      <div class="left-image">
        <img src="@/assets/imgsnew/page9-1.svg" alt="left image" />
      </div>

      <!-- 中间内容区域 -->
      <div class="center-content">
        <h1 class="title">INSPAY</h1>
        <p class="description">
          A revolutionary payment platform, is committed to establishing a close
          connection between digital currency and traditional finance. It deeply
          integrates the payment systems of Visa, Master, and Discover cards,
          unlocking unlimited potential for cross-border consumption for users.
          Whether it's international business travel or overseas shopping, it
          can accurately, efficiently, and securely complete the payment
          process, completely getting rid of the complexity and limitations of
          traditional cross-border payments
        </p>
        <!-- <button class="more-btn">More</button> -->
      </div>

      <!-- 右侧图片 -->
      <div class="right-image">
        <img src="@/assets/imgsnew/page9-2.svg" alt="right image" />
      </div>
    </div>

    <!-- 轮播指示器 -->
    <!-- <div class="carousel-indicators">
      <span
        v-for="i in 5"
        :key="i"
        :class="{ active: i === 1 }"
        class="indicator"
      ></span>
    </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const carouselRef = ref(null);
const isVisible = ref(false);

let observer = null;

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isVisible.value = entry.isIntersecting;
      });
    },
    {
      threshold: 0.2,
    }
  );

  if (carouselRef.value) {
    observer.observe(carouselRef.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped>
.carousel-container {
  width: 100%;
  min-height: 70vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  padding: 30px 0;
}

.carousel-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  position: relative;
  opacity: 0;
  transform: translateY(80px);
  transition: all 1.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.carousel-content.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.carousel-content.animate-out {
  opacity: 0;
  transform: translateY(80px);
}

.left-image,
.right-image {
  flex: 0 0 auto;
  width: 12.5%;
  position: relative;
}

.left-image {
  margin-left: -2.5%;
}

.right-image {
  margin-right: -2.5%;
}

.left-image img,
.right-image img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.center-content {
  flex: 1;
  width: 40%;
  padding: 0 300px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 0 auto;
}

.title {
  font-size: 38px;
  font-weight: bold;
  margin-bottom: 12px;
}

.description {
  font-size: 15px;
  line-height: 1.4;
  color: #666;
  margin-bottom: 15px;
}

.more-btn {
  background-color: #1849a9;
  color: white;
  padding: 12px 40px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.more-btn:hover {
  background-color: #1233ff;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ccc;
  cursor: pointer;
}

.indicator.active {
  background-color: #1849a9;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .carousel-container {
    min-height: auto;
    padding: 20px 0;
  }

  .carousel-content {
    flex-direction: column;
    padding: 15px;
    position: relative;
    overflow: hidden;
  }

  .left-image,
  .right-image {
    width: 35%;
    position: relative;
  }

  .left-image {
    align-self: flex-start;
    margin-left: -5%;
    margin-right: auto;
  }

  .right-image {
    align-self: flex-end;
    margin-right: -5%;
    margin-left: auto;
  }

  .center-content {
    width: 90%;
    padding: 15px 0;
    z-index: 1;
  }

  .title {
    font-size: 28px;
    margin-bottom: 8px;
  }

  .description {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .more-btn {
    padding: 10px 30px;
    font-size: 15px;
  }
}

/* 更小屏幕的样式 */
@media (max-width: 480px) {
  .left-image,
  .right-image {
    width: 40%;
  }

  .left-image {
    margin-left: -4%;
  }

  .right-image {
    margin-right: -4%;
  }

  .title {
    font-size: 24px;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(80px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 确保动画在移动端也能正常工作 */
@media (prefers-reduced-motion: reduce) {
  .carousel-content {
    transition: none;
  }
}
</style>
